/**
 * A ward's availability (M23-T12).
 *
 * **The number and the bar come from the same two props**, so they cannot
 * disagree. On the frame they do: the General row's stepper reads Free `4`
 * while its bar reads `0 free/ 49` (M23 defect D9), and the Dashboard's
 * Capacity panel says Private `0 free/ 49` against the Beds page's total of
 * `10` (defect D8). Both are only reachable when a figure is drawn twice from
 * two places.
 *
 * The fill colour follows the count. The frame paints every bar the same dark
 * red whatever the ward holds, so a fully free ward reads as a crisis.
 */
export function AvailabilityBar({
  free,
  total,
}: {
  free: number
  total: number
}) {
  const pct = total > 0 ? Math.min(100, Math.round((free / total) * 100)) : 0
  const fill =
    total === 0
      ? 'bg-line-2'
      : free === 0
        ? 'bg-bed-bad'
        : pct <= 20
          ? 'bg-bed-warn'
          : 'bg-bed-good'

  return (
    <div className="min-w-32">
      <p className="text-right text-sm tabular-nums text-ink-2">
        {free} free / {total}
      </p>
      <div
        className="mt-1 h-1 w-full rounded-full bg-bg-sunken"
        role="img"
        aria-label={
          total === 0
            ? 'No beds of this type'
            : `${free} of ${total} free`
        }
      >
        <div className={`h-1 rounded-full ${fill}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  )
}
